/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Input, Row, Col } from "antd";
import { jsPDF as JSpdf } from "jspdf";
import "jspdf-autotable";
import * as XLSX from "xlsx";
import moment from "moment";
import IntlMessages from "util/IntlMessages";
import { getTimeLines } from "../../redux/actions/TimeLine";
import PageLimitSwitch from "../../components/PageLimitSwitch";

import generateQuery, { handleSearch as search } from "../../util/table";
import DownloadBtns from "../../components/common/downloadbtns";
import logo from "../../assets/images/kitegateway_icon_dark.png";

export const columns = [
  {
    title: "Created",
    dataIndex: "created_at",
    render: (date) => <span>{moment(date).format("DD/MM/YY h:mm:ss a")}</span>,
    sorter: true,
    search: false,
  },
  {
    title: "P/R",
    dataIndex: "kitegateway_reference",
    sorter: true,
    width: 200,
  },
  {
    title: "Server",
    dataIndex: "server_name",
    sorter: true,
    width: 200,
  },
  {
    title: "Stage",
    dataIndex: "stage",
    sorter: true,
    width: 200,
  },
  {
    title: "Status",
    dataIndex: "status",
    sorter: true,
    render: (transactionStatus) => {
      let color = "default";
      if (
        transactionStatus === "COMPLETED" ||
        transactionStatus === "COMPLETE"
      ) {
        color = "success";
      } else if (transactionStatus === "FAILED") {
        color = "error";
      } else if (transactionStatus === "CONFIRMING") {
        color = "processing";
      } else if (transactionStatus === "PENDING") {
        color = "processing";
      } else if (
        transactionStatus === "CANCELLED" ||
        transactionStatus === "CANCELLED"
      ) {
        color = "warning";
      }

      return (
        <span className="ant-badge ant-badge-status ant-badge-not-a-wrapper">
          <span className={`ant-badge-status-dot ant-badge-status-${color}`} />
          <span className="ant-badge-status-text">{transactionStatus}</span>
        </span>
      );
    },
  },
  {
    title: "Status Message",
    dataIndex: "status_message",
    sorter: true,
  },
  {
    title: "Callback URL",
    dataIndex: "callback_url",
    sorter: true,
  },
  {
    title: "Callback Payload",
    dataIndex: "callback_payload",
    sorter: true,
  },
  {
    title: "Callback Response Code",
    dataIndex: "callback_response_code",
    sorter: true,
    width: 200,
    type: "number",
  },
];

const TimeLineLogs = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, pageSize, currentPage, totalRecords, loading } = useSelector(
    ({ timeline_log }) => timeline_log.timeline_logs
  );
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getTimeLines(pagination));
  }, [dispatch, pageSize, currentPage]);

  // eslint-disable-next-line max-len
  const dataSource =
    data.length &&
    data.length &&
    data.map(
      ({
        _id,
        kitegateway_reference,
        server_name,
        stage,
        status,
        status_message,
        callback_url,
        callback_payload,
        callback_response_code,
        created_at,
        updated_at,
      }) => ({
        key: _id,
        kitegateway_reference,
        server_name,
        stage,
        status,
        status_message,
        callback_url,
        callback_payload,
        callback_response_code,
        created_at,
        updated_at,
      })
    );

  const navigateToView = (record) => ({
    onClick: () => {
      history.push(`/timelines/${record.key}`);
    },
  });

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(
      getTimeLines(generateQuery(pagination, filters, sorter, searchParams))
    );
  };

  const handleSearch = (searchValue) => {
    const query = search(searchValue, dispatch, getTimeLines, columns);
    setSearchParams(query);
  };

  const props = {
    pagination: false,
    onRow: navigateToView,
    onChange: handleOnChange,
    loading,
    columns,
    dataSource,
  };
  function handlePdf(cols, datar, file) {
    const time = moment(Date.now()).format("DD-MM-YYYY");
    const incoming = datar.dataSource;
    const bodyData = [];
    const doc = new JSpdf({ orientation: "landscape" });
    doc.addImage(logo, "PNG", 0, 0, 43.85, 17.06);
    doc.text(`${file} - ${time}`, 50, 10);
    for (let i = 0; i < incoming.length; i += 1) {
      bodyData.push([
        incoming[i].kitegateway_reference,
        incoming[i].server_name,
        incoming[i].stage,
        incoming[i].status,
        incoming[i].status_message,
        incoming[i].callback_url,
        incoming[i].callback_payload,
        incoming[i].callback_response_code,
      ]);
    }
    doc.autoTable({
      margin: { top: 19, left: 1, right: 1 },
      head: [cols.columns],
      body: bodyData,
    });
    doc.save(`${file} - ${time}.pdf`);
  }
  function handleXcl(cols, datar, file) {
    const time = moment(Date.now()).format("DD-MM-YYYY");
    const header = [];
    const col = cols.columns;
    for (let i = 0; i < col.length; i += 1) {
      header.push(col[i].title);
    }
    const incoming = datar.dataSource;
    const dataExtract = [header];
    for (let i = 0; i < incoming.length; i += 1) {
      dataExtract.push([
        incoming[i].kitegateway_reference,
        incoming[i].server_name,
        incoming[i].stage,
        incoming[i].status,
        incoming[i].status_message,
        incoming[i].callback_url,
        incoming[i].callback_payload,
        incoming[i].callback_response_code,
      ]);
    }
    const workb = XLSX.utils.book_new();
    workb.SheetNames.push("Sheet1");
    const wsData = dataExtract;
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    workb.Sheets.Sheet1 = ws;

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Responses");
    XLSX.writeFile(wb, `${file} - ${time}.xlsx`);
  }
  return (
    <div>
      <h2 className="title gx-mb-4">
        <IntlMessages id="timeline_logs.title" />
      </h2>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search Timelines"
          enterButton
          allowClear
          onSearch={handleSearch}
        />
      </div>
      <div className="justify-content-center">
        <DownloadBtns
          handlePdf={() => handlePdf({ columns }, { dataSource }, "Timelines")}
          handleXcl={() => handleXcl({ columns }, { dataSource }, "Timelines")}
        />
        <Table className="gx-table-responsive striped-table" {...props} />
        <Row className="pagination">
          <Col md={12}>
            <PageLimitSwitch
              resourceType="timeline_logs"
              limit={pageSize}
              limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
              totalRecords={totalRecords}
              currentPage={currentPage}
            />
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default TimeLineLogs;
